import React from 'react';
import P3ConfigurationsContainer from 'containers/P3ConfigurationsContainer';
import './P3Configurations.scss';
import { ApolloClient } from 'apollo-client';
import P3TemplatesView from 'views/components/P3Templates/P3TemplatesView';
import ConfigurationsPageCacheContainer from 'containers/ConfigurationsCacheContainer';

interface P3ConfigurationPageProps {
  updateCache: Function;
  client: ApolloClient<any>;
  location: any;
}

const P3ConfigurationsPage: React.FC<P3ConfigurationPageProps> = () => (
  <P3ConfigurationsContainer>
    {({ p3Configurations }) => (
      <ConfigurationsPageCacheContainer configurations={p3Configurations}>
        {({ configurationsPageCache, updateCache, client }) => {
          return (
            <P3TemplatesView
              client={client}
              updateCache={updateCache}
              configurationsPageCache={configurationsPageCache}
            />
          );
        }}
      </ConfigurationsPageCacheContainer>
    )}
  </P3ConfigurationsContainer>
);

export default P3ConfigurationsPage;
